import type { AxiosError } from "axios";
import { getProfileApi } from "@src/api";
import type { UserProfileType, ErrorResponseType } from "@src/types";
import { useQuery } from "@tanstack/react-query";

export function useProfile() {
    return useQuery<UserProfileType, AxiosError<ErrorResponseType>>({
        queryKey: ["user-profile"],
        queryFn: ({ signal }) => getProfileApi(signal),
        // refetchOnWindowFocus: false,
    });
}
